import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const trackView = (path) => {
  try {
    let vid = localStorage.getItem("je_vid");
    if (!vid) {
      vid = (crypto.randomUUID && crypto.randomUUID()) || `v_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem("je_vid", vid);
    }
    axios.post(`${API}/track`, { path, visitor_id: vid }).catch(() => {});
  } catch {
    /* tracking must never break the site */
  }
};
